import React from "react";
import { IconButton } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/pro-solid-svg-icons";
import { GetTypographyContent } from "../Typography/Typography";
import { useDeviceHook } from "../../../utils/hooks/useDeviceHook";
import { ErrorPopupWrapper } from "./ErrorPopup.styles";

export const ErrorPopup: React.FC<{
  message: string;
  hideMessage: (message: string) => void;
  closeMethod?: () => void;
  onTop?: boolean;
}> = ({
  message,
  hideMessage,
  onTop = false,
  closeMethod,
}): React.ReactElement => {
  const { deviceType } = useDeviceHook();
  return (
    <>
      {message && (
        <ErrorPopupWrapper onTop={onTop} deviceType={deviceType}>
          {GetTypographyContent({
            content: message,
            size: "medium",
            textColor: "white",
          })}
          <IconButton
            size="small"
            onClick={() => {
              hideMessage("");
              if (closeMethod) {
                closeMethod();
              }
            }}
            sx={{ color: "white", flexShrink: 0 }}
          >
            <FontAwesomeIcon icon={faXmark} />
          </IconButton>
        </ErrorPopupWrapper>
      )}
    </>
  );
};
